<!--P013-->
<template>
  <div class="div_content">
    <div class="cs_margin_top_sm ui_hierarchy">
      <div class="cs_cursor_pointer ui_txt_hierarchy" @click="$router.push({name:'DistributionCenter'})">配送中心维护</div>
      <div class="ui_txt_hierarchy">&nbsp;>&nbsp;</div>
      <div class="cs_font_bold cs_cursor_pointer ui_txt_hierarchy">添加配送中心</div>
    </div>
    <!--基本信息-->
    <div class="cs_margin_top ui_divider_title">
      <div class="divider_title_info"></div>
      <div class="title_info">基本信息</div>
    </div>
    <div class="cs_margin_top div_search">
      <div class="cs_title_primary cs_text_default type_info_search">配送中心编号</div>
      <input v-model="search.num" class="cs_input cs_radius_lg edtxt_info_search" placeholder="请输入">
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left">配送中心名称</div>
      <input v-model="search.name" class="cs_input cs_radius_lg edtxt_info_search" placeholder="请输入">
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left">负责人</div>
      <input v-model="search.contactName" class="cs_input cs_radius_lg edtxt_info_search ui_margin_left_30" placeholder="非必填">
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left">联系方式</div>
      <input v-model="search.mobileNo" class="cs_input cs_radius_lg edtxt_info_search" placeholder="非必填">
      <br>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_top_sm">所在地址</div>
      <input v-model="search.address" class="cs_input cs_radius_lg edtxt_info_search cs_margin_top_sm width_468 ui_margin_left_44" placeholder="非必填">
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_top_sm cs_margin_left">启用状态</div>
      <div class="cs_radius_lg txt_info_search cs_margin_top_sm">启用</div>
    </div>
    <div class="div_operation_table cs_align_center" style="margin-top:400px;">
      <button @click="btnCancel" class="cs_btn cs_btn_sm ui_btn_ghost_blue"
              type="button">取消
      </button>
      <button @click="btnSave" class="cs_btn cs_btn_sm ui_btn_blue ui_margin_left_88"
              type="button">确认
      </button>
    </div>
    <div class="div_bottom"></div>
  </div>
</template>

<script>
  import WhParameter from "../../assets/csui/parameter/WhParameter"
  export default {
    name: "DistributionCenterAdd",
    components: {},
    data: function () {
      return {
        search: {
          num: "",
          name: "",
          contactName: "",
          mobileNo: "",
          address: "",
        },
      }
    },
    created: function () {
    },
    mounted: function() {
    },
    methods: {
      btnSave(){
        try {
          WhParameter.verifyNotEmpty(this.search.num, "配送中心编号");
          WhParameter.verifyNotEmpty(this.search.name, "配送中心名称");
        }catch (e) {
          this.$toast(e.message);
          return;
        }
        this.$ajax.distributionCenter.add.bind(this)(this.search,(data) => {
          this.$toast("添加成功");
          this.$router.push({name:'DistributionCenter'});
        }, (data) => {
        }, true)
      },
      btnCancel(){
        this.$router.go(-1);
      },
    },
  }
</script>

<style scoped>
  .width_468{
    width: 468px;
  }
</style>



// WEBPACK FOOTER //
// src/page/distribution-center/DistributionCenterAdd.vue